import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Leads_Stages_Type,
  Delete_Leads_Stages_Type,
  Get_All_Leads_Stages_Type,
  Get_Error,
  Get_One_Leads_Stages_Type,
  Update_One_Leads_Stages_Type,
} from '../Types';
export const Insert_Lead_Stages_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/LeadStages`, body);

    dispatch({
      type: Add_Leads_Stages_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Lead Assigned

export const Get_All_Lead_stages_Data_Action = (leadid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/LeadStages?LeadId=${leadid}`);

    dispatch({
      type: Get_All_Leads_Stages_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//=============================================================
//get one Lead Assigned data
//get all Lead Assigned

export const Get_One_Lead_stages_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/LeadStages/${id}`);

    dispatch({
      type: Get_One_Leads_Stages_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//==========================================================

//update one Lead Assigned data
export const Update_one_Lead_stages_Data_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/LeadStages/${id}`, body);

    dispatch({
      type: Update_One_Leads_Stages_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one Lead Assigned action
export const Delete_one_Lead_stages_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/LeadStages/${id}`);

    dispatch({
      type: Delete_Leads_Stages_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
